import React from 'react';
import { TextField } from '@mui/material';

const YearFilter = ({ value, onChange }) => {
  return (
    <TextField
      fullWidth
      label="Minimum Year"
      type="number"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="e.g., 2020"
      InputProps={{
        inputProps: { min: 1900, max: new Date().getFullYear() }
      }}
    />
  );
};

export default YearFilter; 